module.exports = __webpack_public_path__ + "img/payment-ico.8c3db4e7.svg";